<template>
  <section class="users section">
    <div class="container">
      <h1 class="title">Add User</h1>
      <loading v-if="loading" class="white-bg shadow-card" />
      <div class="card shadow-card" v-if="!loading">
        <div class="card-body">
          <div class="row">
            <div class="col">
              <div class="form-group">
                <label>First Name</label>
                <input type="text" v-model="user.first" class="form-control" />
              </div>
            </div>
            <div class="col">
              <div class="form-group">
                <label>Last Name</label>
                <input type="text" v-model="user.last" class="form-control" />
              </div>
            </div>
          </div>
          <div class="form-group">
            <label>Email</label>
            <input
              type="email"
              autocomplete="off"
              v-model="user.email"
              class="form-control"
            />
          </div>

          <div class="form-group">
            <label>Password</label>
            <input
              type="password"
              autocomplete="off"
              v-model="user.password"
              class="form-control"
            />
          </div>
          <div class="form-group">
            <label>Confirm Password</label>
            <input
              type="password"
              autocomplete="off"
              v-model="user.password_confirmation"
              class="form-control"
            />
          </div>
          <div class="form-group">
            <label>Phone Number</label>
            <input
              type="text"
              :key="user.email"
              v-model="user.phone"
              v-cleave="cleave.phone"
              class="form-control"
              minlength="10"
            />
          </div>
          <div class="row">
            <div class="col">
              <div class="form-group">
                <label>Occupation</label>
                <select
                  id="occupation"
                  :disabled="loading"
                  v-model="user.occupation"
                  class="form-control"
                  placeholder="Occupation"
                >
                  <option :value="null">Select An Occupation</option>
                  <option
                    :value="o.id"
                    v-for="o in occupations.data"
                    :key="o.id"
                  >
                    {{ o.name }}
                  </option>
                </select>
              </div>
            </div>
            <div class="col">
              <div class="form-group">
                <label>Account Type</label>
                <select class="form-control" v-model="user.role">
                  <option
                    v-for="(s, i) in users.roles"
                    :key="i"
                    :value="s.key"
                    v-text="s.label"
                  ></option>
                </select>
              </div>
            </div>
          </div>
          <div
            :class="`accordion ${user.role == 'VENDOR' ? 'opened' : 'closed'}`"
          >
            <div class="form-group">
              <label>Vendor Name</label>
              <input type="text" v-model="vendor.name" class="form-control" />
            </div>
            <div class="form-group">
              <label>Vendor Email</label>
              <input type="email" v-model="vendor.email" class="form-control" />
            </div>
            <div class="form-group">
              <label>Vendor Website</label>
              <input type="text" v-model="vendor.site" class="form-control" />
            </div>
            <div class="form-group">
              <label>Vendor Phone</label>
              <input
                type="text"
                v-model="vendor.phone"
                :key="vendor.email"
                class="form-control"
                v-cleave="cleave.phone"
              />
            </div>
          </div>
          <div class="form-group">
            <label>Status</label>
            <div class="custom-control custom-switch">
              <input
                type="checkbox"
                class="custom-control-input"
                id="customSwitch1"
                v-model="user.active"
              />
              <label
                class="custom-control-label cursor-pointer"
                for="customSwitch1"
              >
                <badge
                  type="pill"
                  :color="user.active ? 'success' : 'danger'"
                  v-html="user.active ? 'Active' : 'Inactive'"
                ></badge>
              </label>
            </div>
          </div>
          <div class="form-group">
            <label>Receive Notifications Via</label>
            <div class="d-flex mb-5">
              <div class="custom-control custom-switch ml-3 mr-5">
                <input
                  type="checkbox"
                  class="custom-control-input"
                  id="sendingSMS"
                  v-model="user.enable_sending_sms"
                />
                <label
                  class="custom-control-label cursor-pointer"
                  for="sendingSMS"
                  >SMS</label
                >
              </div>
              <div class="custom-control custom-switch ml-5">
                <input
                  type="checkbox"
                  class="custom-control-input"
                  id="sendingEmail"
                  v-model="user.enable_sending_email"
                />
                <label
                  class="custom-control-label cursor-pointer"
                  for="sendingEmail"
                  >Email</label
                >
              </div>
            </div>
          </div>
          <div class="d-flex align-items-center justify-content-center">
            <button
              @click="doAddUser"
              :disabled="saving"
              class="btn btn-primary btn-block btn-300"
            >
              <span v-if="!saving">Add User</span>
              <span
                class="spinner-border spinner-border-sm"
                v-if="saving"
                role="status"
                aria-hidden="true"
              ></span>
            </button>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>
<script>
import { mapState } from "vuex";
export default {
  name: "UserEdit",
  data() {
    return {
      user: {
        first: "",
        last: "",
        email: "",
        password: "",
        password_confirmation: "",
        phone: "",
        occupation: null,
        role: "CLIENT",
        active: true,
        enable_sending_sms: false,
        enable_sending_email: false,
        is_vendor: false,
      },
      vendor: {
        name: "",
        email: "",
        phone: "",
        site: "",
      },
      cleave: {
        phone: { blocks: [3, 3, 4], delimiter: "-", numericOnly: true },
      },
    };
  },
  computed: {
    ...mapState(["saving", "loading", "users", "occupations"]),
    id: function () {
      return this.$route.params.id;
    },
  },
  mounted() {
    this.$store.commit("SET_LOADING_STATE", true, { root: true });
    this.$store.dispatch("occupations/all");
  },
  methods: {
    doAddUser: function () {
      const isVendor = this.user.role == "VENDOR";

      this.errors = [];
      if (this.user.first == "") {
        this.errors.push("First Name is required");
      }

      if (this.user.last == "") {
        this.errors.push("Last Name is required");
      }

      if (this.user.email == "") {
        this.errors.push("Email is required");
      }

      if (this.user.phone == "") {
        this.errors.push("Phone is required");
      }
      if (this.user.phone !== "" && this.user.phone.length < 12) {
        // 12 including -
        this.errors.push("The phone must be at least 10 digits.");
      }

      if (this.user.password != "") {
        if (this.user.password.length < 8) {
          this.errors.push("The password must be at least 8 characters.");
        }
      } else {
        this.errors.push("Password is required");
      }

      if (isVendor) {
        if (this.vendor.name == "") {
          this.errors.push("Vendor Name is required");
        }
        if (this.vendor.email == "") {
          this.errors.push("Vendor Email is required");
        }
        if (this.vendor.site == "") {
          this.errors.push("Vendor Website is required");
        }
        if (this.vendor.phone == "") {
          this.errors.push("Vendor Phone is required");
        }
      }

      if (this.errors.length <= 0) {
        if (isVendor) {
          this.user.is_vendor = isVendor;
        }
        const dataToSend = this.user;
        if (isVendor) {
          dataToSend.vendor = this.vendor;
        }
        this.$store.dispatch("users/create", dataToSend);
      } else {
        let msg = this.errors.join("<br>");
        this.$store.dispatch(
          "setError",
          { message: msg, title: "Validation Errors" },
          { root: true }
        );
        this.errors = [];
      }
    },
  },
};
</script>

<style scoped lang="scss">
.accordion {
  transition: all 0.7s;
  overflow: hidden;

  &.closed {
    max-height: 0;
  }
  &.opened {
    max-height: 900px;
  }
}
</style>
